import { render, staticRenderFns } from "./StampSelect.vue?vue&type=template&id=bbd07e3a&scoped=true&"
import script from "./StampSelect.ts?vue&type=script&lang=ts&"
export * from "./StampSelect.ts?vue&type=script&lang=ts&"
import style0 from "./StampSelect.css?vue&type=style&index=0&id=bbd07e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd07e3a",
  null
  
)

export default component.exports